import { useQueries } from '@tanstack/react-query';
import { useEffect } from 'react';

import { IFacility, IPage } from 'common/src/types/interfaces';

import { getFiscalYears } from 'portal/src/api/BudgetsService';
import { getFacilities } from 'portal/src/api/FacilitiesService';
import FormView from 'portal/src/components/common/forms/FormView';
import { MESSAGES } from 'portal/src/constants/snackbarMessages';
import useSnackbarHandler from 'portal/src/utils/Snackbar/useSnackbarHandler';

import {
  AccesibilityForm,
  getBudgetCopyDetailsFields,
  getBudgetInformationFields,
} from './BudgetFiscalYearForm.fields';

import { FormCard } from '../../../../../common/forms/FormCard';

const BudgetFiscalYearForm = ({
  formControl,
  accesibility,
}: {
  formControl: any;
  accesibility: AccesibilityForm;
}) => {
  const snackbarHandler = useSnackbarHandler();
  const { control } = formControl;

  const [
    { data: fiscalYears, isError: isFiscalYearsError },
    { data: facilities, isError: isFacilitiesError },
  ] = useQueries({
    queries: [
      {
        queryKey: ['fiscalYears'],
        queryFn: getFiscalYears,
        initialData: [],
      },
      {
        queryKey: ['facilities'],
        queryFn: async () => await getFacilities(),
        initialData: { data: [] } as IPage<IFacility>,
      },
    ],
  });

  const budgetInformationFormFieldsConfig = getBudgetInformationFields(
    accesibility,
    fiscalYears,
  );
  const budgetCopyDetailsFormFieldsConfig = getBudgetCopyDetailsFields(
    accesibility.importPriorFiscalYear,
    facilities.data,
  );
  const firstVisibleCopyDetailsFieldIndex =
    budgetCopyDetailsFormFieldsConfig.findIndex((field) => !field.hidden);
  const formFieldsConfig = accesibility.importPriorFiscalYear
    ? [
        ...budgetInformationFormFieldsConfig,
        ...budgetCopyDetailsFormFieldsConfig.map((field, index) =>
          index === firstVisibleCopyDetailsFieldIndex
            ? { ...field, prependDivider: 'Budget Copy Details' }
            : field,
        ),
      ]
    : budgetInformationFormFieldsConfig;

  useEffect(() => {
    if (isFiscalYearsError && isFacilitiesError) {
      snackbarHandler.error(MESSAGES.GENERIC.ERROR);
    }
  }, [isFacilitiesError, isFiscalYearsError, snackbarHandler]);

  return (
    <FormCard title="Budget Information" showContentDivider={false}>
      <FormView control={control} mainFieldsConfig={formFieldsConfig} />
    </FormCard>
  );
};

export default BudgetFiscalYearForm;
